// utils/formUtils.js

export const handleInputChange = (e, setCurrentFacturation) => {
  const { name, value } = e.target;
  const updatedValue = value === "" ? "0" : value;
  setCurrentFacturation((prev) => ({
    ...prev,
    [name]: updatedValue,
  }));
};

export const handleNumericInput = (e, setCurrentFacturation) => {
  const { name, value } = e.target;

  if (value === "") {
    setCurrentFacturation((prev) => ({ ...prev, [name]: "" }));
    return;
  }

  const regex = /^\d+(,\d{0,2})?$/;

  if (regex.test(value) || value === "") {
    setCurrentFacturation((prev) => ({
      ...prev,
      [name]: value.replace(",", "."),
    }));
  }
};

export const handleReductionChange = (e, setCurrentFacturation) => {
  let value = e.target.value;
  if (value !== "") {
    value = Number(value).toString();
  }

  if (value === "" || (value >= 0 && value <= 100)) {
    setCurrentFacturation((prev) => ({
      ...prev,
      pourcentage_reduction: value,
    }));
  }
};

export const handleRegularisationChange = (e, setCurrentFacturation) => {
  let value = e.target.value.replace(",", ".");
  if (value.length > 1 && value[0] === "0" && value[1] !== ".") {
    value = value.slice(1);
  }

  if ((!isNaN(value) && parseFloat(value) >= 0) || value === "") {
    setCurrentFacturation((prev) => ({
      ...prev,
      regularisation: value,
    }));
  }
};

export const handleAvoirHTChange = (e, setCurrentFacturation) => {
  let value = e.target.value.replace(",", ".");
  if (/^-?\d*\.?\d*$/.test(value)) {
    setCurrentFacturation((prev) => ({
      ...prev,
      avoir_ht: value,
    }));
  }
};

export const handleCommentaireChange = (e, setCurrentFacturation) => {
  const { value } = e.target;
  setCurrentFacturation((prev) => ({
    ...prev,
    commentaire: value,
  }));
};

export const prepareFacturationData = (form) => {
  const numericKeys = [
    "bulletin",
    "stc",
    "maladie",
    "RC",
    "contrat",
    "licenciement",
    "mission_excep",
    "avenant",
    "teulade",
    "acces_silae",
    "pourcentage_reduction",
    "regularisation",
    "avoir_ht",
  ];

  const prepared = {};
  for (const [key, value] of Object.entries(form)) {
    if (numericKeys.includes(key)) {
      prepared[key] = value === "" ? 0 : parseFloat(value);
    } else {
      prepared[key] = value;
    }
  }
  return {
    ...prepared,
    commentaire: form.commentaire,
    statut: "En revue",
  };
};
